const ChristianAboutHeader = [
    { id: 1, label: "Address", var: "address" },
    { id: 2, label: "City", var: "city" },
    { id: 3, label: "State", var: "state" },
    { id: 4, label: "Email", var: "email" },
    { id: 5, label: "Year Established", var: "established" },
    { id: 6, label: "Year first MBBS batch graduated", var: "yearfirst" },
    { id: 7, label: "Head of the Institution", var: "headoftheinstitution" },
    { id: 8, label: "Designation of Head of the Institution", var: "designation" },
    { id: 9, label: "Institute type", var: "institutetype" },
    { id: 10, label: "Website", var: "website" },
    { id: 11, label: "Designation of Head of the Institution", var: "designation2" },
    { id: 12, label: "institutetype", var: "institutetype2" },
    { id: 13, label: "Anti-ragging cell", var: "antiraggingcell" },
    { id: 14, label: "National Service Scheme unit", var: "nationalserviceschemeunit" },
    { id: 15, label: "Internal Complaints Committee cell", var: "internalcomplaintscommitteecell" },
    { id: 16, label: "Internal Quality Assurance Cell", var: "internalqualityassurancecell" },
    { id: 17, label: "Total number of MBBS students graduated since the college was established", var: "totalnumberofmbbs" },
    
];

export default ChristianAboutHeader;
